import React from 'react';

import { Alert, AlertTitle, Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useForm } from 'react-final-form';

import { Field, TextField } from 'src/components/finalForm';
import { VerificationRequestCreateFormFields } from 'src/constants/verificationRequest';

import { VerificationRequestCreateFormValues } from './types';

type VerificationRequestCreateByVerifierModalFormErrorBoxProps = {
  mt?: number;
};

export const VerificationRequestCreateByVerifierModalFormErrorBox: React.FC<
  VerificationRequestCreateByVerifierModalFormErrorBoxProps
> = ({ mt = 2 }) => {
  const { getFieldState, change } = useForm<VerificationRequestCreateFormValues>();

  const errorFieldState = getFieldState(VerificationRequestCreateFormFields.error);

  const resetError = React.useCallback(() => {
    change(VerificationRequestCreateFormFields.error, null);
  }, [change]);

  const renderAlert = React.useCallback(() => {
    const value = errorFieldState?.value;

    if (value) {
      return (
        <Alert sx={{ mt }} severity="error" onClose={resetError}>
          <AlertTitle>Attention</AlertTitle>
          {value}
        </Alert>
      );
    }

    return null;
  }, [errorFieldState?.value, mt, resetError]);

  return (
    <React.Fragment>
      <Box sx={visuallyHidden}>
        <Field name={VerificationRequestCreateFormFields.error} component={TextField} />
      </Box>

      {renderAlert()}
    </React.Fragment>
  );
};
